import { render, staticRenderFns } from "./SchoolIntroView.vue?vue&type=template&id=697935a8&scoped=true"
import script from "./SchoolIntroView.vue?vue&type=script&lang=js"
export * from "./SchoolIntroView.vue?vue&type=script&lang=js"
import style0 from "./SchoolIntroView.vue?vue&type=style&index=0&id=697935a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697935a8",
  null
  
)

export default component.exports